module.exports = __webpack_public_path__ + "static/media/thermage-white.29a3eec8.svg";